module.exports = __webpack_public_path__ + "static/media/refrigDamaged.be6fa0f3.png";